module.exports = __webpack_public_path__ + "img/A whole year-rafiki.6ccb26ef.svg";